import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-deep" data-id="element-103" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-104" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-white" data-id="element-105" data-mp="3ghc2o28413o8">
          No-Lines <span className="text-gold" data-id="element-106" data-mp="32lrmhejrmzki">Lacrosse</span>
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-107" data-mp="36q92d2n08sq0">
          Every youth practice, planned — so no kid waits in line.
        </p>

        <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-1 text-[13px] text-white/70" data-id="element-108" data-mp="38qvoyiyxrr6">
          <a href="mailto:help@iclcollective.com" className="inline-flex min-h-[44px] items-center px-1 hover:text-white hover:underline" data-id="element-109" data-mp="3lec9ifcsaage">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-navy-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-110" data-mp="29z6x2jmuoxjl">
          No-Lines Lacrosse is a practice-planning resource for youth lacrosse
          coaches. It is not affiliated with or endorsed by any lacrosse governing
          body or league. It does not replace coach certification, safeguarding
          or background-check requirements, first-aid training, or your
          league&apos;s rules on equipment, contact and safety, including
          concussion protocols. Always check your league rulebook. Results depend
          on the coach and the team; no specific outcome is guaranteed. © No-Lines
          Lacrosse 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}